// =============================================
// The three machine types available as pill
// filters on the History page.
//
// The values match the Postgres machine_type
// enum exactly so they can be passed directly
// to the Supabase .eq("machine_type", …) call
// without any transformation layer.
//
// Order matches the DataTable sort order:
// CNC → Edge → Saw.
// =============================================
export type HistoryMachineType = "CNC" | "Edge" | "Saw";

export const HISTORY_MACHINE_TYPE_FILTERS: HistoryMachineType[] = [
  "CNC",
  "Edge",
  "Saw",
];

export const DEFAULT_HISTORY_MACHINE_TYPE: HistoryMachineType = "CNC";
